import React, { Component, useEffect, useRef, useState } from "react";
import InventoryDetails from "../components/InventoryDetails";
import Table from "../ui/Table";
import Space from "../ui/Space";
import InventoryHistory from "../components/InventoryHistory";
//import { search } from "../temp";
import InventoryTitleLinkList from "../components/InventoryTitleLinkList";
import InventoryList from "../components/InventoryList";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Nav from "../ui/Nav";
import { createModal } from "../hooks/createModal";
import InventorySearch from "../popups/InventorySearch";
import { useGlobals } from "../hooks/Globals";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import { ROUTES } from "../utils/Routes";
import InventoryIndex from "../popups/InventoryIndex";
import InventoryMessage from "../popups/InventoryMessage";
import dayjs from "dayjs";
import { diffObjs, istl, kbdEvent } from "../utils/Utils";
import { createScreen } from "../hooks/createScreen";
import AuthorPickerScreen from "../screens/AuthorPickerScreen";
import InventoryAdjust from "../popups/InventoryAdjust";
import InventoryPubstock from "../components/InventoryPubstock";
import Confirm from "../popups/Confirm";
import Divider from "../ui/Divider";
import TextButton from "../ui/TextButton";
import { stock_structure } from "../data_structures/Stock";
import InventoryExtra from "../popups/InventoryExtra";
import SupplierDetails from "../components/SupplierDetails";
import SuppliersList from "../components/SuppliersList";

export default function SuppliersController(props) {

    const { signal = {}, setController = () => { } } = props;
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [selected, setSelected] = useState({});

    const [filters, setFilters] = useState({ sort: "name", limit: 45 });


    const suppliers_nav = [
        { key: KBD.ESCAPE, action: () => { setController("home") } },
        { text: "Cpy" },
        { text: "Del" },
        { text: "Edt" },
        { text: "@Edt" },
        { text: "Ind" },
        { text: "Label" },
        { text: "Msg" },
        { text: "New" },
        { text: "Prt" },
        { text: "Srch" },
        { text: "View" },
        { text: "Web" },
        { text: "Xtra" },
    ]


    useEffect(() => {
        const cleanup = listen(ROUTES.SUPPLIERS.SUPPLIERS, suppliers_nav);
        return cleanup;
    }, [suppliers_nav])

    useEffect(() => { window.bm_state.value = ROUTES.SUPPLIERS.SUPPLIERS }, []);



    return (
        <div>
            <div><SupplierDetails selected={selected} /></div>
            <div>
                <div>
                    <div className="shim" />
                    <Space style={{ "alignItems": "flex-start" }} size={5}>

                    </Space>
                </div>
            </div>
            <div style={{"marginTop" : "-537px"}}>
            <SuppliersList
                // filterLocal={filterLocal}
                signal={signal}
                // in_stock={in_stock}
                // isTitleLink={isTitleLink}
                // view={state.view}
                // align={align}
                // setAlign={setAlign}
                selected={selected}
                setSelected={setSelected}
                loading={loading}
                setLoading={setLoading}
                data={data}
                setData={setData}
                filters={filters}
                setFilters={setFilters}
                route={ROUTES.SUPPLIERS.SUPPLIERS}
            />
            </div>
            <Nav nav={suppliers_nav} />

        </div>
    )


}